import React from "react";

export default function Section5() {
  return (
    <div>
      <div className=" m-10 md:my-10 md:mx-10 md:p-12">
        <h1 className="text-[24px] md:text-[40px]  p-6 md: md:text-center">We've helped thousands of people save money on their groceries</h1>
      </div>
    </div>
  );
}
